import React from "react";
import { Field, ConfigInput } from "./Field";

const ZOHO_REGIONS = [
  { code: "com", label: "Global (.com)" },
  { code: "eu", label: "Europe (.eu)" },
  { code: "in", label: "India (.in)" },
  { code: "com.au", label: "Australia (.com.au)" },
  { code: "jp", label: "Japan (.jp)" },
];

export default function ZohoFields({ config, setConfig }) {
  return (
    <>
      <Field label="Region" required
        hint="Sets the token endpoint host; the api_domain returned by Zoho is used for API calls.">
        <select data-testid="dest-zoho-region"
          className="w-full border border-black px-2 py-1.5 mt-1 font-mono text-xs"
          value={config.zoho_region || "com"}
          onChange={(e) => setConfig("zoho_region", e.target.value)}>
          {ZOHO_REGIONS.map((r) => <option key={r.code} value={r.code}>{r.label}</option>)}
        </select>
      </Field>

      <Field label="Module">
        <select className="w-full border border-black px-2 py-1.5 mt-1 font-mono text-xs"
          value={config.module || "Leads"} onChange={(e) => setConfig("module", e.target.value)}>
          <option value="Leads">Leads</option>
          <option value="Contacts">Contacts</option>
        </select>
      </Field>

      <Field label="Default company (Leads module)" colSpan={2}
        hint={<>Zoho requires <span className="font-mono">Company</span> on Leads. If your CSV doesn&rsquo;t provide one, we&rsquo;ll fill this value.</>}>
        <ConfigInput name="default_company" config={config} setConfig={setConfig}
          placeholder="LeadFlow-imported" />
      </Field>

      <Field label="OAuth client ID" required>
        <ConfigInput name="oauth_client_id" config={config} setConfig={setConfig}
          testId="dest-zoho-client-id" required />
      </Field>
      <Field label="OAuth client secret" required>
        <ConfigInput name="oauth_client_secret" config={config} setConfig={setConfig}
          testId="dest-zoho-client-secret" required type="password" />
      </Field>

      <Field label="Refresh token" required colSpan={2}
        hint={<>Token URL defaults to <span className="font-mono">
          https://accounts.zoho.{config.zoho_region || "com"}/oauth/v2/token</span>.</>}>
        <ConfigInput name="oauth_refresh_token" config={config} setConfig={setConfig}
          testId="dest-zoho-refresh" required type="password"
          placeholder="From the initial Zoho OAuth grant with ZohoCRM.modules.leads.CREATE scope" />
      </Field>
    </>
  );
}
